import { IState } from 'shared/store';
import { EUserType } from 'shared/types/user';

export const selectUserType = (state: IState) => {
  if (state.isHomeowner) {
    return EUserType.Homeowner;
  }

  if (state.offerData.user?.isAgent) {
    return EUserType.Specialist;
  }

  return EUserType.Undefined;
};
